import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

import { request as baseRequest } from "@xo-union/fetch-request-builder";
import { wrapCreateSessionResponse, wrapMemberResponse, wrapError } from "./responseWrappers/index.js";
import configure from "./configure/index.js";
import validatePayload from "../validations/index.js";

var _request = /*#__PURE__*/new _WeakMap();

var _payloadValidator = /*#__PURE__*/new _WeakMap();

export default class MembershipClient {
  constructor() {
    let {
      payloadValidator = validatePayload,
      request = baseRequest,
      ...config
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classPrivateFieldInitSpec(this, _request, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _payloadValidator, {
      writable: true,
      value: void 0
    });

    const {
      host,
      apiKey,
      version
    } = configure(config);

    _classPrivateFieldSet(this, _payloadValidator, payloadValidator);

    _classPrivateFieldSet(this, _request, request.host(host).query({
      apikey: apiKey
    }).set('Accept-Version', version));
  }

  createMember(params) {
    _classPrivateFieldGet(this, _payloadValidator).call(this, params);

    return _classPrivateFieldGet(this, _request).post('/members').set('Content-Type', 'application/json').send({
      members: params
    }).readJsonBody().mapResponse(wrapMemberResponse).mapError(wrapError);
  }

  createSession(params) {
    return _classPrivateFieldGet(this, _request).post('/sessions').set('Content-Type', 'application/json').send({
      sessions: params
    }).readJsonBody().mapResponse(wrapCreateSessionResponse).mapError(wrapError);
  }

  isLoggedIn() {
    let {
      token
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _classPrivateFieldGet(this, _request).head('/sessions').set('MEMBERSHIP-SESSION-TOKEN', token);
  }

  getMember(_ref) {
    let {
      token
    } = _ref;
    return _classPrivateFieldGet(this, _request).get('/members').set('MEMBERSHIP-SESSION-TOKEN', token).readJsonBody().mapResponse(wrapMemberResponse).mapError(wrapError);
  }

  updateMember(_ref2) {
    let {
      token,
      member
    } = _ref2;

    _classPrivateFieldGet(this, _payloadValidator).call(this, member);

    return _classPrivateFieldGet(this, _request).patch('/members').set('MEMBERSHIP-SESSION-TOKEN', token).set('Content-Type', 'application/json').send({
      members: member
    }).readJsonBody().mapResponse(wrapMemberResponse).mapError(wrapError);
  }

  deleteSession(_ref3) {
    let {
      token
    } = _ref3;
    return _classPrivateFieldGet(this, _request).del('/sessions').set('MEMBERSHIP-SESSION-TOKEN', token);
  }

  changePassword(_ref4) {
    let {
      token,
      member
    } = _ref4;

    _classPrivateFieldGet(this, _payloadValidator).call(this, member);

    return _classPrivateFieldGet(this, _request).put('/members/change_password').set('MEMBERSHIP-SESSION-TOKEN', token).set('Content-Type', 'application/json').send(member).readJsonBody().mapResponse(wrapMemberResponse).mapError(wrapError);
  }

  deactivate(_ref5) {
    let {
      token
    } = _ref5;
    return _classPrivateFieldGet(this, _request).patch('/members/deactivate').set('MEMBERSHIP-SESSION-TOKEN', token).readJsonErrorBody().mapError(wrapError);
  }

  sendResetPasswordLink(_ref6) {
    let {
      email
    } = _ref6;
    return _classPrivateFieldGet(this, _request).post('/members/send_reset_password_link').set('Content-Type', 'application/json').send({
      email
    }).readJsonErrorBody().mapError(wrapError);
  }

  resetPasswordTokens(params) {
    return _classPrivateFieldGet(this, _request).patch('/members/reset_password_tokens').set('Content-Type', 'application/json').send(params).readJsonErrorBody().mapError(wrapError);
  }

  validResetPasswordToken(resetPasswordToken) {
    return _classPrivateFieldGet(this, _request).get(`/members/reset_password_tokens/${resetPasswordToken}`).readJsonErrorBody().mapError(wrapError);
  }

}